var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fareFeatures)?_c('div',_vm._l((_vm.fareFeatures.features),function(feature,index){return _c('v-chip',{key:index,staticStyle:{"text-align":"center"},attrs:{"justify-center":""}},[_vm._v("\n      "+_vm._s(feature)+"\n    ")])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }